module.exports = __webpack_public_path__ + "img/icon_product12.d2b66fa4.png";